import {useEffect} from 'react'

import useAtmosphere from './useAtmosphere'
import useEventCallback from './useEventCallback'

const useAtmosphereListener = (
  eventName,
  callback
) => {
  const atmosphere = useAtmosphere()
  const cb = useEventCallback(callback)
  useEffect(() => {
    atmosphere.eventEmitter.on(eventName , cb)
    return () => {
      atmosphere.eventEmitter.off(eventName, cb)
    }
  }, [atmosphere.eventEmitter, eventName, cb])
}

export default useAtmosphereListener
